import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Globals } from '../../shared/services/globals';

@Injectable({
  providedIn: 'root'
})
export class MainSpecialityService {

  constructor(private httpRes: HttpRequestService, private globals: Globals) { }

  GetMainSpecialities()
  {
      return this.httpRes.GetRequest(`MainSpeciality/GetMainSpecialities`);
  }

  GetMainSpecialityById(id)
  {
      return this.httpRes.GetRequest(`MainSpeciality/GetMainSpecialityById/${id}`);
  }

  AddMainSpeciality(mainSpeciality: any){
    return this.httpRes.postRequest(`MainSpeciality/AddMainSpeciality`,mainSpeciality);
  }

  DeleteMainSpeciality(id){
    return this.httpRes.GetRequest(`MainSpeciality/DeleteMainSpeciality/${id}`);
  }

  UpdateMainSpeciality(mainSpeciality : any){
    return this.httpRes.postRequest(`MainSpeciality/UpdateMainSpeciality`,mainSpeciality);
  }

}
